'use client';

import { useEffect, useRef, useState } from 'react';

const MOBILE_BREAKPOINT = 1024;
/** Minimum scroll distance before the header changes state, to avoid jitter. */
const DIRECTION_THRESHOLD = 8;

/**
 * On mobile the header hides while scrolling down and comes back on scroll up.
 * Desktop always keeps it visible.
 */
export const useMobileHeaderVisibility = () => {
  const [isVisible, setIsVisible] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth >= MOBILE_BREAKPOINT) {
        setIsVisible(true);
        lastScrollY.current = window.scrollY;
        return;
      }

      const currentScrollY = window.scrollY;
      const delta = currentScrollY - lastScrollY.current;

      if (currentScrollY <= 0) {
        setIsVisible(true);
      } else if (delta > DIRECTION_THRESHOLD) {
        setIsVisible(false);
      } else if (delta < -DIRECTION_THRESHOLD) {
        setIsVisible(true);
      }

      lastScrollY.current = currentScrollY;
    };

    lastScrollY.current = window.scrollY;
    handleScroll();

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return [isVisible, setIsVisible] as const;
};
